module.exports = __webpack_public_path__ + "img/logo vertebra blanco.e5ba5607.svg";